<template>
  <div>
    <c-box
      title="Работы по проекту"
      :loading="loading"
      shadow
    >
      <template v-slot:header-right>
        <button
          class="btn btn-secondary"
          :class="{inactive: view !== 'ЖдутСогласования'}"
          @click="view = 'ЖдутСогласования'"
        >
          Ждут согласования
        </button>

        <button
          class="btn btn-success"
          :class="{inactive: view !== 'ВыполненныеРаботы'}"
          @click="view = 'ВыполненныеРаботы'"
        >
          Готово
        </button>

        <button
          class="btn btn-warning"
          :class="{inactive: view !== 'ЗапланированныеРаботы'}"
          @click="view = 'ЗапланированныеРаботы'"
        >
          Запланированные
        </button>
      </template>

      <div class="row">
        <div class="col-md-12">
          <template v-if="!loading && works.length">
            <div
              v-for="work of works"
              :key="work.ЗаголовокРаботы"
              class="work"
              @click="toggle(work.ЗаголовокРаботы)"
            >
              <img :src="require('../../../img/monthly-report/check-mark.png')">
              <span class="text-bold">
                {{ work.ЗаголовокРаботы }}
              </span>
              <img
                :style="{ transform: isExpanded(work.ЗаголовокРаботы) ? 'rotate(180deg)' : 'none' }"
                :src="require('../../../img/monthly-report/expander.png')"
              >
              <div v-if="expanded.includes(work.ЗаголовокРаботы)">
                <p style="margin-top: 5px">
                  {{ work.ОписаниеРаботы }}
                </p>
                <div
                  v-if="work.ТаблицаПунктовРабот"
                  class="list"
                >
                  <p class="text-bold">
                    {{ work.ЗаголовокСписка }}
                  </p>
                  <ul>
                    <li
                      v-for="l of work.ТаблицаПунктовРабот.filter(i => i.Использовать)"
                      :key="l.Пункт"
                    >
                      {{ l.Пункт }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr>
            </div>
          </template>
          <no-data v-if="!loading && !works.length" />
        </div>
      </div>
    </c-box>
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'

export default {
  name: 'DynamicWorks',
  components: { NoData, CBox },
  mixins: [diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      view: 'ВыполненныеРаботы',
      expanded: []
    }
  },
  computed: {
    works () {
      return this.data.filter(i => i.ИмяГруппыРаботы === this.view)
    }
  },
  methods: {
    toggle (item) {
      if (!this.expanded.includes(item)) {
        this.expanded.push(item)
      } else {
        this.expanded = this.expanded.filter(i => i !== item)
      }
    },
    isExpanded (item) {
      return this.expanded.includes(item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.btn {
  background-color: transparent;
}

.btn-secondary {
  border: 1px solid #333;
}

.btn.inactive {
  border: none;
}

.btn-success {
  color: $textSuccessColor;
}

.btn-warning {
  color: $textWarningColor;
}

.list {
  background-color: #d9ebd3;
  padding: 17px;
  border-radius: 10px;
}

.list ul {
  padding-inline-start: 17px;
}

.work {
  cursor: pointer;
}

.work > div > p {
  padding-left: 17px;
}
</style>
